import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';

const SuccessAlert = () => {
      let navigate = useNavigate();

    const onConfirm = () => {
        navigate("/");
    }
    const onCancel = () => {
        navigate("/");
    };
  return (
    <div className="container">
      <SweetAlert
        success
        title="Submited Successfully"
        onConfirm={onConfirm}
        onCancel={onCancel}
      >
        We will soon contact you.
      </SweetAlert>
    </div>
  );
}

export default SuccessAlert